import React, { type FC } from 'react';

const CoachCardSkeleton: FC = () => {
  return (
    <div className="flex animate-pulse flex-col items-start justify-start py-6 md:flex-row lg:px-6">
      <div className="flex w-full grow items-center justify-start md:w-min md:grow-0">
        <div className="size-16 shrink-0 rounded-full bg-gray-200 md:h-25 md:w-25" />
        <div className="ml-4 flex w-full flex-col items-start justify-center md:hidden">
          <div className="h-6 w-2/12 bg-gray-200 font-medium" />
          <div className="mt-1 h-8 w-5/12 bg-gray-200" />
        </div>
      </div>
      <div className="mt-5 w-full grow md:ml-7 md:mt-0">
        <div className="h-6 w-3/4 bg-gray-200 font-medium md:w-2/12" />
        <div className="mt-1 h-8 bg-gray-200 md:w-5/12" />
        <div className="mt-1 h-5 w-3/4 bg-gray-200 md:w-2/12" />
        <div className="mt-2 h-8 bg-gray-200 md:w-3/12" />
      </div>
    </div>
  );
};

export default CoachCardSkeleton;
